import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookOpen, faShareNodes, faUsers, faRupeeSign, faHome, faUserFriends, faWallet } from '@fortawesome/free-solid-svg-icons';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

const KarmayogiHome = () => {
  useEffect(() => {
    ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);
  }, []);

  const chartData = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
    datasets: [
      {
        label: 'Earnings',
        data: [1200, 2450, 1800, 2200, 2150, 3000],
        borderColor: '#22c55e',
        backgroundColor: 'rgba(34, 197, 94, 0.1)',
        tension: 0.4,
        pointBackgroundColor: '#22c55e',
        pointRadius: 4,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: '#22c55e',
        titleColor: '#000',
        bodyColor: '#000',
        cornerRadius: 8,
      },
    },
    scales: {
      x: {
        grid: { color: '#374151' },
        ticks: { color: '#22c55e' },
      },
      y: {
        grid: { color: '#374151' },
        ticks: { color: '#22c55e' },
      },
    },
  };

  return (
    <div className="min-h-screen bg-black text-green-500 flex flex-col">
      {/* MAIN CONTENT */}
      <div className="flex-1 bg-black border-b border-green-400 pb-2">
        {/* HEADER */}
        <header className="text-center py-2 px-4 bg-black border-b border-green-400 pb-2">
          <h1 className="text-xl lg:text-2xl font-bold text-green-500">Karmayogi Circle</h1>
          <p className="text-sm lg:text-lg mt-1 italic text-white">Learn. Grow. Earn with Dignity.</p>
        </header>

        {/* WELCOME */}
        <section className="px-6 mt-1">
          <h2 className="text-lg lg:text-xl font-semibold">Welcome, Rajesh</h2>
          <p className="text-sm lg:text-lg text-white mt-1">Level: Certified Karmayogi</p>
        </section>

        {/* PROGRESS */}
        <section className="px-6 mt-1">
          <p className="text-lg lg:text-xl text-white font-medium mb-2">Your Karmayogi Path to Progress</p>
          <div className="mt-1 flex flex-col lg:flex-row items-center gap-8">
            <div className="w-full lg:w-2/3">
              <div className="bg-gray-700 rounded-full h-10 relative overflow-hidden">
                <div className="bg-green-500 h-full rounded-full transition-all duration-500" style={{ width: '30%' }}></div>
              </div>
              <p className="mt-2 text-lg text-white">30% Complete</p>
            </div>

            <div className="w-40 h-40 relative">
              <svg width="160" height="160" viewBox="0 0 160 160">
                <circle
                  cx="80"
                  cy="80"
                  r="70"
                  stroke="#374151"
                  strokeWidth="16"
                  fill="transparent"
                />
                <circle
                  cx="80"
                  cy="80"
                  r="70"
                  stroke="#22c55e"
                  strokeWidth="16"
                  fill="transparent"
                  strokeDasharray="439.8"
                  strokeDashoffset="307.86"
                  strokeLinecap="round"
                  transform="rotate(-90 80 80)"
                />
              </svg>
              <div className="absolute inset-0 flex flex-col items-center justify-center">
                <span className="text-xl lg:text-xl text-white font-bold">30%</span>
                <span className="text-xs lg:text-sm mt-1 text-white">Complete</span>
              </div>
            </div>
          </div>
        </section>

        {/* ACTION CARDS */}
        <section className="px-6 mt-2 grid grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="bg-gray-900 border border-green-500 rounded-xl p-2 flex flex-col">
            <FontAwesomeIcon icon={faBookOpen} className="text-xl lg:text-2xl mb-2" />
            <h3 className="text-sm lg:text-lg text-white font-semibold">Today’s Learning</h3>
            <p className="mt-1 text-sm lg:text-lg text-white">Safety Tips on the Job</p>
            <button
              onClick={() => console.log('Start Now clicked')}
              className="mt-1 bg-green-500 text-white py-2 rounded-lg font-medium hover:bg-green-400 transition"
            >
              Start Now
            </button>
          </div>

          <div className="bg-gray-900 border border-green-500 rounded-xl p-2 flex flex-col">
            <FontAwesomeIcon icon={faShareNodes} className="text-lg lg:text-xl mb-2" />
            <h3 className="text-sm lg:text-lg text-white font-semibold">Apply & Share</h3>
            <p className="mt-3 text-sm lg:text-lg text-white flex-1">Log Your Practice</p>
            <button
              onClick={() => console.log('Submit clicked')}
              className="mt-6 bg-green-500 text-white py-3 rounded-lg font-medium hover:bg-green-400 transition"
            >
              Submit
            </button>
          </div>

          <div className="bg-gray-900 border border-green-500 rounded-xl p-2 flex flex-col">
            <FontAwesomeIcon icon={faUsers} className="text-xl lg:text-2xl mb-2" />
            <h3 className="text-sm lg:text-lg text-white font-semibold">Karmayogi Circle</h3>
            <p className="mt-1 text-sm lg:text-lg text-white flex-1">12 Members in Your Circle</p>
            <button
              onClick={() => console.log('INVITE FRIEND clicked')}
              className="mt-2 bg-green-500 text-white py-3 rounded-lg font-medium hover:bg-green-400 transition"
            >
              Invite Friend
            </button>
          </div>

          <div className="bg-gray-900 border border-green-500 rounded-xl p-6 flex flex-col">
            <FontAwesomeIcon icon={faRupeeSign} className="text-xl lg:text-2xl mb-4" />
            <h3 className="text-sm lg:text-lg text-white font-semibold">This Month’s Earnings</h3>
            <p className="mt-1 text-sm lg:text-lg text-white font-bold">₹2,150</p>
            <p className="text-sm lg:text-lg text-white mt-1">Knowledge Share</p>
            <button
              onClick={() => console.log('See Details clicked')}
              className="mt-2 bg-green-500 text-white py-3 rounded-lg font-medium hover:bg-green-400 transition"
            >
              See Details
            </button>
          </div>
        </section>

        {/* GROWTH SHARE HISTORY */}
        <section className="px-6 mt-2">
          <h2 className="text-lg lg:text-xl font-semibold">Growth Share History</h2>
          <div className="mt-2 space-y-4">
            <div className="flex justify-between py-1 text-white border-b border-gray-700">
              <span>Mar</span>
              <span>₹1,800</span>
            </div>
            <div className="flex justify-between py-1 text-white border-b border-gray-700">
              <span>Feb</span>
              <span>₹2,450</span>
            </div>
            <div className="flex justify-between py-1 text-white">
              <span>Jan</span>
              <span>₹1,200</span>
            </div>
          </div>
          <button
            onClick={() => console.log('View All history clicked')}
            className="mt-2 border border-green-500 text-green-500 py-2 px-4 rounded-lg font-medium hover:bg-green-500 hover:text-black transition"
          >
            View All
          </button>
        </section>

        {/* INSIGHTS */}
        <section className="px-6 mt-2">
          <div className="bg-gray-900 border border-green-500 rounded-xl p-2 text-center">
            <p className="text-xl lg:text-2xl text-white italic">“5 Workers Improved Skills Due to You”</p>
            <button
              onClick={() => console.log('Share Experience clicked')}
              className="mt-2 bg-green-500 text-white py-3 px-8 rounded-lg font-medium hover:bg-green-400 transition"
            >
              Share Experience
            </button>
          </div>
        </section>

        {/* CHART */}
        <section className="px-6 mt-2">
          <div className="h-80">
            <Line data={chartData} options={chartOptions} />
          </div>
        </section>

        {/* FOOTER QUOTE */}
        <footer className="px-6 py-2 text-center italic text-lg lg:text-xl mt-2">
          <p className="text-white">“A Karmayogi learns, applies, and uplifts others without leaving their main work.”</p>
        </footer>
      </div>

      {/* BOTTOM NAV */}
      <nav className="bg-black border-t border-green-500">
        <div className="flex justify-around py-2">
          <button className="flex flex-col items-center">
            <FontAwesomeIcon icon={faHome} className="text-xl" />
            <span className="text-xs text-white mt-1">My Path</span>
          </button>
          <button className="flex flex-col items-center">
            <FontAwesomeIcon icon={faUserFriends} className="text-xl" />
            <span className="text-xs text-white mt-1">My Circle</span>
          </button>
          <button className="flex flex-col items-center">
            <FontAwesomeIcon icon={faWallet} className="text-xl" />
            <span className="text-xs text-white mt-1">Earnings</span>
          </button>
        </div>
      </nav>
    </div>
  );
};

export default KarmayogiHome;
